import { Button } from 'antd';
import React from 'react';

import IntegrationIcon from 'components/icons/IntegrationIcon/integration.svg?react';
import getAgriWebbMarketplaceCardUrl from 'utils/agriwebb/get-agriwebb-marketplace-card-url';

import './styles.less';

const PermissionRequest = () => (
  <div className="PermissionRequest-container">
    <IntegrationIcon className="PermissionRequest-icon" />
    <div className="section-heading mb-8">
      Request permission to connect your account
    </div>
    <div className="body-copy mb-16">
      You need to be an Admin or Supervisor to connect enterprises to
      AgriWebb.
    </div>
    <Button
      className="PermissionRequest-button"
      onClick={() => {
        window.location.href = getAgriWebbMarketplaceCardUrl();
      }}
    >
      Back
    </Button>
  </div>
);

export default PermissionRequest;
